import React from 'react'
import '../CSS/style.css'
import '../CSS/responsive.css'
import Works from './works'
import Testimonials from './testimonials'
import ImgSlider from './hero_section'

export default function HomePage() {
    document.title = "UnlockCode"
  return (
    <>
    <ImgSlider />
    <Works />
    <Testimonials />
    
    </>
  )
}
